import { ReactNode } from 'react';

import { Button, ChakraBox, ChakraFlex } from '@equip.health/ui';
import { PageModel } from 'survey-core';

import { SurveyAccordionEvents } from '~/analytics/surveyAccordionEvents';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

const FULL_SCREEN_DIMENSIONS = {
  top: 52,
  bottom: 90,
  left: 500,
};

const TOP_LEVEL_ID = 'patient-survey-full-screen-container__side-navigation';

type FullScreenContainerProps = {
  children: ReactNode;
  currentPage: number;
  isLoading: boolean;
  onSkip: (name: string) => void;
  pages: PageModel[];
  responseExternalId: string;
};

const FullScreenContainer = ({
  children,
  currentPage,
  isLoading,
  onSkip,
  pages,
  responseExternalId,
}: FullScreenContainerProps) => {
  const { trackEvent } = useAnalytics();

  const handleSectionTabClick = (name: string, pageIndex: number) => {
    trackEvent(SurveyAccordionEvents.surveyAccordionSectionTabClicked, {
      'From Page': currentPage,
      'To Page': pageIndex,
      'Section Name': name,
      'Response ID': responseExternalId,
    });
    onSkip(name);
  };

  return (
    <>
      <ChakraBox
        background="white"
        borderRadius={0}
        height={`calc(100vh - ${FULL_SCREEN_DIMENSIONS.top}px)`}
        overflow="auto"
        position="absolute"
        top={`${FULL_SCREEN_DIMENSIONS.top}px`}
        width={`${FULL_SCREEN_DIMENSIONS.left}px`}
      >
        <ChakraFlex direction="column">
          {/* @ts-expect-error-next-line type is inaccurate, this is not how they want us to do it i believe but works for interim */}
          {pages.map(({ propertyHash: { name } }: PageModel, i: number) => (
            <Button
              colorScheme={currentPage === i ? 'primary' : 'gray'}
              height="76px"
              id={`${TOP_LEVEL_ID}__${name}`}
              isDisabled={isLoading}
              key={`survey-side-nav-${name}`}
              margin="12px 40px 0 80px"
              onClick={() => handleSectionTabClick(name, i)}
              padding="16px"
              variant={currentPage === i ? 'solid' : 'outline'}
              width="380px"
            >
              {name}
            </Button>
          ))}
        </ChakraFlex>
      </ChakraBox>
      <ChakraBox
        height={`calc(100vh - ${
          FULL_SCREEN_DIMENSIONS.bottom + FULL_SCREEN_DIMENSIONS.top
        }px)`}
        left={`${FULL_SCREEN_DIMENSIONS.left}px`}
        overflow="scroll"
        padding="8px"
        position="fixed"
        top={`${FULL_SCREEN_DIMENSIONS.top}px`}
        width={`calc(100vw - ${FULL_SCREEN_DIMENSIONS.left}px)`}
      >
        {children}
      </ChakraBox>
    </>
  );
};

export default FullScreenContainer;
